export default {
  dashBoard: 'แดชบอร์ด',
  treatmentReport: 'รายงาน',
  queuePage: 'หน้าคิว',
  appointment: 'ตารางนัดหมาย',
  patient: 'คนไข้',
  opdReport: 'รายการ OPD',
  doctor: 'ทะเบียนแพทย์',
  ingredient: 'ส่วนผสม',
  drugFormulaList: 'สูตรยา',
  product: 'สินค้า',
  stock: 'สต็อก',
  pos: 'แคชเชียร์',
  posOrders: 'ออเดอร์',
  service: 'บริการ',
  course: 'คอร์ส',
  setting: 'ตั้งค่าระบบ'
}
